import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import blog1 from './img/blog/blog1.jpg';
import blog2 from './img/blog/blog2.jpg';
import blog3 from './img/blog/blog3.jpg';
import blog4 from './img/blog/blog4.jpg';
import { Container, Row, Col } from 'reactstrap';
import history from '../../history';

class News extends React.Component {
  goToScheduleDemo = () => history.push('/demo');
  render() {
    const {
      styles: s,
    } = this.props;
    return (
      <div id="newsHere">
        <section className={cx(s.row, s.sectpad, s.RecentNewsArea, s.recentNewsAreaThree, s.keyBg)}>
          <Container>
            <div className={cx(s.sectionTitleThree, s.titleGr, s.mb60)}>
                <h2>Awards <span>and</span> Accolades</h2>
            </div>
            <Row className={s.RecentContent}>
              <Col sm="3" xs="12" className={s.newsCols}>
                <div className={cx(s.recent, s.recentTwo)}>
                  <a className={s.recentImage}>
                    <img className={s.imgResponsive} src={blog1} alt="" />
                  </a>
                  <div className={s.recentNewsText}>
                    <a>
                      <h4>Selected for AWS Activate program for startups</h4>
                    </a>
                    <h6>18 August, 2017</h6>
                    {/* <p>Lorem ipsum dolor sit amet, consectetuer piingerat volutpat. Ut wisi enim ad minim veniam Lorem ipsum dolor sit amet.</p> */}
                    {/* <a>Read more <i className={cx(s.fa, s.faAngleDoubleRight)} aria-hidden="true"></i></a> */}
                  </div>
                </div>
              </Col>
              <Col sm="3" xs="12" className={s.newsCols}>
                <div className={cx(s.recent, s.recentTwo)}>
                  <a className={s.recentImage}>
                    <img className={s.imgResponsive} src={blog2} alt="" />
                  </a>
                  <div className={s.recentNewsText}>
                    <a>
                      <h4>Selected for IBM Global entrepreneur program</h4>
                    </a>
                    <h6>11 August, 2017</h6>
                    {/* <p>Lorem ipsum dolor sit amet, consectetuer piingerat volutpat. Ut wisi enim ad minim veniam Lorem ipsum dolor sit amet.</p> */}
                    {/* <a>Read more <i className={cx(s.fa, s.faAngleDoubleRight)} aria-hidden="true"></i></a> */}
                  </div>
                </div>
              </Col>
              <Col sm="3" xs="12" className={s.newsCols}>
                <div className={cx(s.recent, s.recentTwo)}>
                  <a className={s.recentImage}>
                    <img className={s.imgResponsive} src={blog3} alt="" />
                  </a>
                  <div className={s.recentNewsText}>
                    <a>
                      <h4>Oracle Startup Cloud accelerator – among top 11</h4>
                    </a>
                    <h6>4th July, 2018</h6>
                    {/* <p>Lorem ipsum dolor sit amet, consectetuer piingerat volutpat. Ut wisi enim ad minim veniam Lorem ipsum dolor sit amet.</p> */}
                    {/* <a>Read more <i className={cx(s.fa, s.faAngleDoubleRight)} aria-hidden="true"></i></a> */}
                  </div>
                </div>
              </Col>
              <Col sm="3" xs="12" className={s.newsCols}>
                <div className={cx(s.recent, s.recentTwo)}>
                  <a className={s.recentImage} href="https://www.thehindu.com/news/cities/Delhi/four-iit-kharagpur-alumni-launch-hr-technology-start-up/article24963362.ece?utm_campaign=amp_article_share&utm_medium=referral&utm_source=spotmentor.com" target="_blank">
                    <img className={s.imgResponsive} src={blog4} alt="" />
                  </a>
                  <div className={s.recentNewsText}>
                    <a href="https://www.thehindu.com/news/cities/Delhi/four-iit-kharagpur-alumni-launch-hr-technology-start-up/article24963362.ece?utm_campaign=amp_article_share&utm_medium=referral&utm_source=spotmentor.com" target="_blank">
                      <h4>Covered by The Hindu <br /><br /></h4>
                    </a>
                    <h6>17th September, 2018</h6>
                    {/* <p>Lorem ipsum dolor sit amet, consectetuer piingerat volutpat. Ut wisi enim ad minim veniam Lorem ipsum dolor sit amet.</p> */}
                    {/* <a href="https://www.thehindu.com/news/cities/Delhi/four-iit-kharagpur-alumni-launch-hr-technology-start-up/article24963362.ece?utm_campaign=amp_article_share&utm_medium=referral&utm_source=spotmentor.com" target="_blank">Read more <i className={cx(s.fa, s.faAngleDoubleRight)} aria-hidden="true"></i></a> */}
                  </div>
                </div>
              </Col>
            </Row>
            <Row className={s.requestRow}>
              <Col md="12">
                <div className={s.requestInfo}>
                  <div className={cx(s.sectionTitleThree, s.titleGr)}>
                    {/* <h2>Request <span>a callback</span></h2> */}
                    <h2><span>Schedule a</span> demo</h2>
                  </div>
                  <p style={{ marginTop: '60px', padding: '0 50px' }}>
                    Spotmentor is an integrated learning platform which identifies skill gaps, recommends best suited learning content to close those gaps and then tracks the impacts on business goals.
                  </p>
                  <div style={{ textAlign: 'center' }} className={s.scheduleDemo}>
                    <button
                      onClick={() => this.goToScheduleDemo('/demo')}
                    >
                      Schedule Demo
                    </button>
                  </div>
                  {/* <form className={cx(s.rqMailform, s.group, s.groupBottom)}>
                    <div className={cx(s.groupItem, s.formWrap)}>
                      <input className={cx(s.formInput, s.formControl)} type="text" name="name" placeholder="First Name" />
                    </div>
                    <div className={cx(s.groupItem, s.formWrap)}>
                      <input className={cx(s.formInput, s.formControl)} type="text" name="phone" placeholder="Phone Number" />
                    </div>
                    <div className={cx(s.groupItem, s.formWrap)}>
                      <select className={cx(s.formInput, s.selectFilter, s.formControl)} tabIndex="-1" aria-hidden="true" id="regula-generated-683421">
                        <option value="1">I Would Like to Discuss</option>
                        <option value="2">I Wouldn't Like to Discuss</option>
                      </select>
                    </div>
                    <div className={cx(s.groupItem, s.groupItemSm)}>
                      <button className={cx(s.btn, s.btnBlock, s.btnWhiteOutline)} type="submit">submit</button>
                    </div>
                  </form> */}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }
}

export default News;



// WEBPACK FOOTER //
// ./src/routes/home/News.js